var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendPaymentAdvicesGradient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8137)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8137",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8137)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_27_8137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.0234C38.2678 49.0234 49.0234 38.2678 49.0234 25C49.0234 11.7322 38.2678 0.976562 25 0.976562C11.7322 0.976562 0.976562 11.7322 0.976562 25C0.976562 38.2678 11.7322 49.0234 25 49.0234Z",
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_27_8137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2625 39.073C39.2671 39.2398 39.2375 39.4057 39.1756 39.5606C39.1136 39.7155 39.0206 39.8561 38.9022 39.9736C38.6662 40.1697 38.3684 40.276 38.0616 40.2738H11.6428C11.3378 40.2657 11.0433 40.1605 10.8021 39.9736C10.6838 39.8561 10.5907 39.7155 10.5288 39.5606C10.4668 39.4057 10.4372 39.2398 10.4419 39.073V21.4805H39.2625V39.073Z",
    fill: "#5B6DC6"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_27_8137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.901 39.9711C38.6649 40.1671 38.3672 40.2734 38.0604 40.2712H11.6414C11.3364 40.263 11.042 40.1579 10.8008 39.9711L24.8506 27.9023L38.901 39.9711Z",
    fill: "#4A5691"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_27_8137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1782 15.8948V24.4209L25.6313 31.2658C25.3975 31.4412 25.1131 31.536 24.8208 31.536C24.5285 31.536 24.2441 31.4412 24.0103 31.2658L14.5234 24.4209V13.373C14.5243 13.0547 14.6511 12.7497 14.8762 12.5246C15.1013 12.2996 15.4063 12.1727 15.7246 12.1719H31.3955L35.1782 15.8948Z",
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.4571 14.9339C31.4555 15.0605 31.4792 15.1862 31.5269 15.3035C31.5746 15.4208 31.6453 15.5273 31.7348 15.6168C31.8243 15.7064 31.9309 15.7771 32.0482 15.8248C32.1655 15.8725 32.2912 15.8962 32.4178 15.8945H35.1796L31.457 12.1719V14.9339H31.4571Z",
    fill: "#CDD6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3939 24.2416H29.355C29.0548 24.902 28.5744 25.3824 27.9139 25.7427C27.1934 26.1626 26.2928 26.343 25.212 26.343C24.1912 26.343 23.2905 26.163 22.5701 25.8026C21.8497 25.4423 21.2492 24.962 20.8889 24.2415C20.5276 23.5571 20.3419 22.7937 20.3485 22.0199C20.3331 21.1613 20.5399 20.3133 20.9488 19.5582C21.3688 18.7776 21.9096 18.2372 22.6302 17.8769C23.3977 17.5084 24.2405 17.3234 25.0918 17.3366C25.82 17.3321 26.5394 17.4965 27.1934 17.8169C27.7938 18.1171 28.2741 18.5374 28.5742 19.1378C28.8872 19.7084 29.0524 20.3484 29.0546 20.9992C29.055 21.7787 28.8021 22.5373 28.3341 23.1607C27.7336 24.0013 26.953 24.3619 25.9923 24.3619C25.7861 24.3634 25.5817 24.3225 25.3919 24.2418C25.2719 24.1217 25.1517 24.0015 25.1517 23.8218C24.9895 23.9932 24.794 24.1296 24.5772 24.2225C24.3603 24.3154 24.1268 24.363 23.8908 24.3622C23.3505 24.3622 22.9302 24.1821 22.6299 23.8218C22.2697 23.4616 22.0895 22.9813 22.0895 22.3808C22.0837 21.6561 22.2926 20.9459 22.69 20.3398C23.1701 19.6193 23.8308 19.2591 24.6114 19.2591C24.8601 19.2549 25.1058 19.3132 25.326 19.4286C25.5463 19.544 25.7341 19.7128 25.8723 19.9196L25.9923 19.3792H27.2533L26.5327 22.7405C26.494 22.8772 26.4738 23.0184 26.4727 23.1604C26.4686 23.193 26.4719 23.2261 26.4823 23.2573C26.4927 23.2885 26.5099 23.3169 26.5327 23.3406C26.5929 23.4006 26.5929 23.4006 26.6528 23.4006C26.7729 23.4006 27.013 23.2805 27.2532 23.1004C27.5897 22.8505 27.858 22.5202 28.0338 22.1397C28.2181 21.744 28.3203 21.3151 28.334 20.8788C28.3416 20.5167 28.2704 20.1573 28.1252 19.8255C27.9801 19.4937 27.7645 19.1974 27.4934 18.9573C26.9529 18.417 26.1724 18.1767 25.1516 18.1767C24.3111 18.1767 23.5906 18.3568 22.9902 18.7171C22.418 19.0576 21.9587 19.559 21.6694 20.1587C21.3692 20.7591 21.2495 21.4196 21.2495 22.1401C21.2518 22.7719 21.4173 23.3923 21.7298 23.9414C22.09 24.4817 22.5104 24.902 23.1108 25.1426C23.7614 25.3936 24.4545 25.516 25.1518 25.5028C25.8041 25.5054 26.4528 25.404 27.0733 25.2026C27.5816 24.9882 28.0335 24.6593 28.3939 24.2416ZM23.2905 22.3203C23.2905 22.7402 23.3506 22.9807 23.5308 23.2209C23.711 23.401 23.891 23.5211 24.1313 23.5211C24.2983 23.517 24.4623 23.476 24.6116 23.401C24.7459 23.3192 24.8672 23.2181 24.9718 23.1008C25.1519 22.9207 25.2721 22.6205 25.3917 22.2601C25.5047 21.9314 25.5655 21.587 25.5719 21.2394C25.5719 20.8792 25.5118 20.6389 25.3317 20.3988C25.1515 20.2186 24.9714 20.0986 24.7313 20.0986C24.4626 20.1079 24.2066 20.2146 24.0108 20.3988C23.7705 20.5789 23.5904 20.8791 23.4703 21.2994C23.3575 21.6282 23.2969 21.9727 23.2905 22.3203Z",
    fill: "#BF6087"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27_8137",
    x: -5.02344,
    y: -5.02344,
    width: 70.0469,
    height: 70.0469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.302 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_8137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_8137",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_27_8137",
    x: 4.44141,
    y: 18.4805,
    width: 40.8203,
    height: 30.793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_8137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_8137",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_27_8137",
    x: 4.80078,
    y: 24.9023,
    width: 40.1016,
    height: 24.3672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_8137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_8137",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_27_8137",
    x: 8.52344,
    y: 9.17188,
    width: 32.6562,
    height: 31.3633,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27_8137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27_8137",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendPaymentAdvicesGradient);
export default __webpack_public_path__ + "static/media/send_payment_advices_gradient.b750f87ff9c7f3e31cbc38482b668c2b.svg";
export { ForwardRef as ReactComponent };